<template>
  <div class="bg-slate-50 min-h-screen p-4 md:p-8">
    <div class="max-w-7xl mx-auto">
      <div v-if="loader" class="flex flex-col justify-center items-center py-12">
        <svg class="animate-spin h-10 w-10 text-emerald-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-slate-500 font-medium">Carregando relatório...</span>
      </div>
      <div v-else-if="showMessage" class="bg-white rounded-xl shadow-sm border border-slate-200 p-12 flex flex-col items-center justify-center text-center">
        <v-icon color="orange" size="48" class="mb-4">mdi-alert-circle-outline</v-icon>
        <p class="font-bold text-slate-700 text-lg mb-2">Ops! Algo deu errado.</p>
        <p class="text-slate-500 max-w-md">{{ message }}</p>
        <button class="mt-6 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold py-2 px-6 rounded-lg transition-colors" @click="loadTceReport">Tentar Novamente</button>
      </div>
      <GenericReport
        v-else
        :data="dataReport"
        :prefecture="prefecture"
        :cod="cod"
        :month="month"
        :year="year"
        ref="allComponent"
      />
    </div>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
import GenericReport from "./veiculosReportModel";
export default {
  components: { GenericReport },
  mixins: [Helpers],
  props: {
    month: null,
    year: null,
    prefecture_id: null,
    cod: null,
  },
  data: () => ({
    dataReport: [],
    prefecture: null,
    showMessage: false,
    loader: false,
    message: "",
  }),
  created() {
    this.loadTceReport();
    this.Helpers;
  },
  methods: {
    loadTceReport() {
      this.message = "";
      this.showMessage = false;
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/tce/veiculos/${this.prefecture_id}/${this.cod}`)
        .then((r) => {
          if (r.data.error) {
            this.message = r.data.error;
            this.showMessage = true;
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
          } else {
            this.dataReport = r.data;
            this.$http.get(`/prefectures/${this.prefecture_id}`).then((p) => {
              this.prefecture = p.data[0] || {};
              this.loader = false;
              this.$store.dispatch("setLoader", this.loader);
            }).catch(e => {
              console.error(e);
              this.prefecture = {};
              this.loader = false;
              this.$store.dispatch("setLoader", this.loader);
            });
          }
        })
        .catch((e) => {
          console.error(e);
          this.message = "Erro ao carregar os dados do relatório. Verifique sua conexão ou tente novamente mais tarde.";
          this.showMessage = true;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        });
    },
  },
};
</script>

<style></style>
